import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { END_URL } from "../../config";
import "./ResetPassword.css";

function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract token and email from query params
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const onSubmit = async (data) => {
    if (!token || !email) {
      setError("Invalid or missing password reset token/email.");
      return;
    }

    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${END_URL}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token,
          email,
          password: data.password,
          password_confirmation: data.confirmPassword,
        }),
      });

      const result = await response.json();
      if (response.ok) {
        setSuccess("Password reset successfully! Redirecting to login...");
        setTimeout(() => navigate("/"), 2000);
      } else {
        setError(
          result.message ||
            (result.errors
              ? Object.values(result.errors).flat().join(" ")
              : "Password reset failed")
        );
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="reset-pass-main">

    <div className="reset-password-container">

      <h2>Reset Your Password</h2>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {!success && (
        <div className="reset-password-box">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="input-group">
              <label htmlFor="password">New Password</label>
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters",
                  },
                })}
                autoComplete="new-password"
              />
              {showPassword ? (
                <FaRegEye
                  onClick={() => setShowPassword(false)}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <FaRegEyeSlash
                  onClick={() => setShowPassword(true)}
                  style={{ cursor: "pointer" }}
                />
              )}
              {errors.password && (
                <p className="error">{errors.password.message}</p>
              )}
            </div>

            <div className="input-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                id="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                {...register("confirmPassword", {
                  required: "Please confirm your password",
                  validate: (value) =>
                    value === watch("password") || "Passwords do not match",
                })}
                autoComplete="new-password"
              />
              {showConfirmPassword ? (
                <FaRegEye
                  onClick={() => setShowConfirmPassword(false)}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <FaRegEyeSlash
                  onClick={() => setShowConfirmPassword(true)}
                  style={{ cursor: "pointer" }}
                />
              )}
              {errors.confirmPassword && (
                <p className="error">{errors.confirmPassword.message}</p>
              )}
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        </div>
      )}
    </div>

    </div>
  );
}

export default ResetPassword;
